module.exports = require('./helpers/bundle-url').getBundleURL('6YPom') + "logo-dark.ba5147f0.svg";